// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.12.0 (commit 92fdc93b9507ac89061cafb4f4909b3a1162e59d).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import and reexport all reducer arg types
import OnConnectReducer from "./on_connect_reducer";
export { OnConnectReducer };
import OnDisconnectReducer from "./on_disconnect_reducer";
export { OnDisconnectReducer };
import RegisterAccountReducer from "./register_account_reducer";
export { RegisterAccountReducer };
import LoginWithPasswordReducer from "./login_with_password_reducer";
export { LoginWithPasswordReducer };
import RunServerTickReducer from "./run_server_tick_reducer";
export { RunServerTickReducer };
import MoveReducer from "./move_reducer";
export { MoveReducer };
import EmitHitSplatReducer from "./emit_hit_splat_reducer";
export { EmitHitSplatReducer };
import SendChatReducer from "./send_chat_reducer";
export { SendChatReducer };
import TerrainEditReducer from "./terrain_edit_reducer";
export { TerrainEditReducer };
import NpcSpawnerPlaceReducer from "./npc_spawner_place_reducer";
export { NpcSpawnerPlaceReducer };
import NpcSpawnerUpdateReducer from "./npc_spawner_update_reducer";
export { NpcSpawnerUpdateReducer };
import NpcSpawnerDeleteReducer from "./npc_spawner_delete_reducer";
export { NpcSpawnerDeleteReducer };
import AttackServerNpcReducer from "./attack_server_npc_reducer";
export { AttackServerNpcReducer };

// Import and reexport all procedure arg types

// Import and reexport all table handle types
import ChatMessageRow from "./chat_message_table";
export { ChatMessageRow };
import HitSplatRow from "./hit_splat_table";
export { HitSplatRow };
import IdGenRow from "./id_gen_table";
export { IdGenRow };
import NpcSpawnerRow from "./npc_spawner_table";
export { NpcSpawnerRow };
import PlayerRow from "./player_table";
export { PlayerRow };
import ServerNpcRow from "./server_npc_table";
export { ServerNpcRow };
import TerrainChunkRow from "./terrain_chunk_table";
export { TerrainChunkRow };
import TerrainStrokeRow from "./terrain_stroke_table";
export { TerrainStrokeRow };
import TickJobRow from "./tick_job_table";
export { TickJobRow };
import UserCredentialsRow from "./user_credentials_table";
export { UserCredentialsRow };
import WorldStateRow from "./world_state_table";
export { WorldStateRow };

// Import and reexport all types
import AttackServerNpc from "./attack_server_npc_type";
export { AttackServerNpc };
import ChatMessage from "./chat_message_type";
export { ChatMessage };
import EmitHitSplat from "./emit_hit_splat_type";
export { EmitHitSplat };
import HitSplat from "./hit_splat_type";
export { HitSplat };
import IdGen from "./id_gen_type";
export { IdGen };
import Init from "./init_type";
export { Init };
import LoginWithPassword from "./login_with_password_type";
export { LoginWithPassword };
import Move from "./move_type";
export { Move };
import NpcSpawner from "./npc_spawner_type";
export { NpcSpawner };
import NpcSpawnerDelete from "./npc_spawner_delete_type";
export { NpcSpawnerDelete };
import NpcSpawnerPlace from "./npc_spawner_place_type";
export { NpcSpawnerPlace };
import NpcSpawnerUpdate from "./npc_spawner_update_type";
export { NpcSpawnerUpdate };
import OnConnect from "./on_connect_type";
export { OnConnect };
import OnDisconnect from "./on_disconnect_type";
export { OnDisconnect };
import Player from "./player_type";
export { Player };
import RegisterAccount from "./register_account_type";
export { RegisterAccount };
import RunServerTick from "./run_server_tick_type";
export { RunServerTick };
import SendChat from "./send_chat_type";
export { SendChat };
import ServerNpc from "./server_npc_type";
export { ServerNpc };
import TerrainChunk from "./terrain_chunk_type";
export { TerrainChunk };
import TerrainEdit from "./terrain_edit_type";
export { TerrainEdit };
import TerrainStroke from "./terrain_stroke_type";
export { TerrainStroke };
import TickJob from "./tick_job_type";
export { TickJob };
import UserCredentials from "./user_credentials_type";
export { UserCredentials };
import WorldState from "./world_state_type";
export { WorldState };

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema(
  __table({
    name: 'chat_message',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'chat_message_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ChatMessageRow),
  __table({
    name: 'hit_splat',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'hit_splat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HitSplatRow),
  __table({
    name: 'id_gen',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'id_gen_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, IdGenRow),
  __table({
    name: 'npc_spawner',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'by_tile', algorithm: 'btree', columns: [
        'tx',
        'tz',
      ] },
    ],
    constraints: [
      { name: 'npc_spawner_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, NpcSpawnerRow),
  __table({
    name: 'player',
    indexes: [
      { name: 'owner', algorithm: 'btree', columns: [
        'owner',
      ] },
      { name: 'by_public_id', algorithm: 'btree', columns: [
        'publicId',
      ] },
    ],
    constraints: [
      { name: 'player_owner_key', constraint: 'unique', columns: ['owner'] },
    ],
  }, PlayerRow),
  __table({
    name: 'server_npc',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'by_spawner_id', algorithm: 'btree', columns: [
        'spawnerId',
      ] },
    ],
    constraints: [
      { name: 'server_npc_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ServerNpcRow),
  __table({
    name: 'terrain_chunk',
    indexes: [
      { name: 'chunkKey', algorithm: 'btree', columns: [
        'chunkKey',
      ] },
    ],
    constraints: [
      { name: 'terrain_chunk_chunkKey_key', constraint: 'unique', columns: ['chunkKey'] },
    ],
  }, TerrainChunkRow),
  __table({
    name: 'terrain_stroke',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'terrain_stroke_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TerrainStrokeRow),
  __table({
    name: 'tick_job',
    indexes: [
      { name: 'scheduledId', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'tick_job_scheduledId_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, TickJobRow),
  __table({
    name: 'user_credentials',
    indexes: [
      { name: 'by_bound_owner', algorithm: 'btree', columns: [
        'boundOwner',
      ] },
      { name: 'username', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'user_credentials_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, UserCredentialsRow),
  __table({
    name: 'world_state',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'world_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorldStateRow),
);

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("register_account", RegisterAccountReducer),
  __reducerSchema("login_with_password", LoginWithPasswordReducer),
  __reducerSchema("run_server_tick", RunServerTickReducer),
  __reducerSchema("move", MoveReducer),
  __reducerSchema("emit_hit_splat", EmitHitSplatReducer),
  __reducerSchema("send_chat", SendChatReducer),
  __reducerSchema("terrain_edit", TerrainEditReducer),
  __reducerSchema("npc_spawner_place", NpcSpawnerPlaceReducer),
  __reducerSchema("npc_spawner_update", NpcSpawnerUpdateReducer),
  __reducerSchema("npc_spawner_delete", NpcSpawnerDeleteReducer),
  __reducerSchema("attack_server_npc", AttackServerNpcReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "1.12.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. */
export const tables = __convertToAccessorMap(tablesSchema.schemaType.tables);

/** A typed query builder for this remote SpacetimeDB module. */
export const query: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

